import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 12052E35-8005-45AD-8901-7861C8404EF8
 * name food-takeout-box
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/food-takeout-box.svg
 * tags
 * - Food / Drink 
 */
export const FoodTakeoutBoxIcon = createSvgIcon(<><path d="M5.26 11H18.74L18.07 20H5.93L5.26 11M9 4H14.97L19 7.38L20.59 5.79L22 7.21L19.21 10H4.79L2 7.21L3.41 5.8L5 7.38L9 4Z" /></>, 'FoodTakeoutBoxIcon');
export default FoodTakeoutBoxIcon